export function emailCheck (email) {
  var emailreg = /^([a-zA-Z0-9]+[_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
  if (!emailreg.test(email)) {
    return false
  }
  return true
}
export const isWeiXin = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}
export function pwdCheck (pwd) {
  var pwdreg = /^[a-zA-Z]\w{5,17}$/
  if (!pwdreg.test(pwd)) {
    return false
  }
  return true
}
export function phoneNumCheck (phoneNUm) {
  var phoneNumreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  if (!phoneNumreg.test(phoneNUm)) {
    return false
  }
  return true
}
export function stringCheck (string) {
  var result = removeSpace(string)
  if (result.length === 0) {
    return false
  }
  return true
}

function removeSpace (string) {
  var result
  result = string.trim()
  result = result.replace(/\s/g, '')
  return result
}

export function timeFormat (time) {
  let date = new Date(time)
  let month = date.getMonth() + 1
  let day = date.getDay()
  let hour = date.getHours()
  let minutes = date.getMinutes()
  let str = `${month}-${day} ${hour}:${minutes}`
  return str
}
// 写cookies
export const setCookie = (c_name, value, expiredays) => {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie =
    c_name +
    '=' +
    escape(value) +
    (expiredays == null ? '' : ';expires=' + exdate.toGMTString())
}

// 读取cookies
export const getCookie = name => {
  var arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if ((arr = document.cookie.match(reg))) return unescape(arr[2])
  else return null
}

// 删除cookies
export const delCookie = name => {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null) { document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() }
}

export const timestampToTime = now => {
  var year = now.getFullYear()
  var month =
    now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1
  var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
  var hour = now.getHours() < 10 ? '0' + now.getHours() : now.getHours()
  var minute =
    now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
  var second =
    now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds()
  // return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
  // return year + '.' + month + '.' + date + '-' + hour + ':' + minute
  return year + '-' + month + '-' + date
}

export const formatDate = (date, mode = '-') => {
  var year = date.getFullYear()
  var month =
  date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  return `${year}${mode}${month}${mode}${day}`
}

export const formatTime = (date, mode = '-') => {
  var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  var minute =
  date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  var second =
  date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return `${formatDate(date)} ${hour}:${minute}:${second}`
}

export const IsCard = (str) => {
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  return reg.test(str)
}



// WEBPACK FOOTER //
// ./src/util/util.js